import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../../Layout"
import { SolicitacaoForm } from "../../modais"

class NotificacaoCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/solicitacaoesclarecimento")
  }
  render() {
    return (
      <Layout tabActive="Fiscalização">
        <SolicitacaoForm callBackSolicitacao={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(NotificacaoCreateForm)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/notificacao/NotificacaoCreateForm.js